<template>
  <div id="app">
   <router-view/>
  </div>
</template>

<script>
import ModernFaceMesh from './utils/modernFaceMesh.js';

export default {
  data() {
    return {
      faceMeshInstance: null, // 用于存储 FaceMesh 实例
    };
  },
  mounted() {
    this.initFaceMesh();
  },
 methods: {
    async initFaceMesh() {
      try {
        console.log('🚀 初始化现代化 MediaPipe FaceLandmarker...');
        // 直接使用现代化版本
        this.faceMeshInstance = new ModernFaceMesh();
        await this.faceMeshInstance.initialize();
      this.faceMeshInstance.setOptions({
        maxNumFaces: 1,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });

      this.faceMeshInstance.onResults(this.faceMeshResults);

      // 将 faceMesh 实例绑定到根实例
      this.$root.faceMesh = this.faceMeshInstance;
        
        console.log('✅ 现代化 MediaPipe FaceLandmarker 初始化成功');
        
      } catch (error) {
        console.error('❌ 现代化 MediaPipe FaceLandmarker 初始化失败:', error);
      }
    },
    
    faceMeshResults(results) {
      // 处理 FaceMesh 结果的全局回调函数
      console.log('📊 现代版本 FaceMesh 结果:', results);
    },
  },
  
  beforeDestroy() {
    // 清理资源
    if (this.faceMeshInstance && this.faceMeshInstance.close) {
      this.faceMeshInstance.close();
    }
  },
};
</script>


<style lang="scss">
*{
  list-style: none;
  margin: 0;
  padding: 0;
}
html, body, #app {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  touch-action: manipulation;
}

</style>
